// import { RegisterContainer } from "../../containers/RegisterSystem/RegisterContainer";
import { ConsiderProfileContainer } from "../../containers/RegisterSystem/ConsiderProfileContainer"

export function ConsiderProfilePage() {
    return (
        <ConsiderProfileContainer />
    )
}